import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Wrench } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent } from '../components/ui/card';
import { useAuth } from '../lib/AuthContext';
import { errMsg } from '../lib/api';

export default function SignupPage() {
  const { signup, config } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ shop_name: '', owner_name: '', email: '', mobile: '', password: '' });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signup(form);
      toast.success('Welcome! Your 60-day Pro trial has started.');
      navigate('/dashboard');
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-dvh flex items-center justify-center px-4 py-8 bg-[radial-gradient(1200px_circle_at_20%_0%,rgba(14,165,164,0.10),transparent_55%),radial-gradient(900px_circle_at_90%_10%,rgba(253,231,179,0.30),transparent_50%)]">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center space-y-2">
          <span className="inline-flex h-12 w-12 rounded-2xl bg-[hsl(var(--primary))] text-white items-center justify-center shadow-[var(--shadow-soft)]">
            <Wrench className="h-6 w-6" />
          </span>
          <h1 className="text-2xl font-semibold font-display">Create your shop</h1>
          <p className="text-sm text-[hsl(var(--muted-foreground))]">Free 60-day Pro trial. No card needed — {config?.app_name || 'Auto Pampanga'}.</p>
        </div>
        <Card className="rounded-2xl shadow-[var(--shadow-card)] border-black/5">
          <CardContent className="pt-6">
            <form onSubmit={submit} className="space-y-3">
              <Input data-testid="signup-shop-name-input" required minLength={2} placeholder="Shop name" value={form.shop_name} onChange={set('shop_name')} className="h-12 rounded-xl" />
              <Input data-testid="signup-owner-name-input" required minLength={2} placeholder="Your full name" value={form.owner_name} onChange={set('owner_name')} className="h-12 rounded-xl" />
              <Input data-testid="signup-email-input" type="email" required placeholder="Email" value={form.email} onChange={set('email')} className="h-12 rounded-xl" />
              <Input data-testid="signup-mobile-input" required placeholder="Mobile (e.g. 09171234567)" value={form.mobile} onChange={set('mobile')} className="h-12 rounded-xl" />
              <Input data-testid="signup-password-input" type="password" required minLength={8} placeholder="Password (min 8 characters)" value={form.password} onChange={set('password')} className="h-12 rounded-xl" />
              <Button data-testid="signup-submit-button" type="submit" disabled={busy} className="w-full h-12 rounded-xl text-base">
                {busy ? 'Creating…' : 'Start free trial'}
              </Button>
            </form>
          </CardContent>
        </Card>
        <p className="text-center text-sm text-[hsl(var(--muted-foreground))]">
          Already have an account?{' '}
          <Link data-testid="signup-login-link" to="/login" className="font-medium text-[hsl(var(--primary))]">Log in</Link>
        </p>
      </div>
    </div>
  );
}
